import React from "react";
// import _get from "lodash/get";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { formatDate, formatDateTime } from "../../actions/momentActions";
import SupportTable from "./SupportTable";
// import Button from "@mui/material/Button";
import SearchBar from "./SearchBar";
import {
  getQueueCount,
  getQueue,
  getWaittime,
} from "../../actions/supportActions";
import AddSupportForm from "./AddSupportForm";

const styles = (theme) => ({
  addWrapper: {
    padding: 10,
  },
  searchText: {
    display: "inline-block",
    marginTop: 10,
    marginLeft: 5,
  },
});

export class Reseller extends React.Component {
  state = {
    isAdd: false,
    carrier: null,
    limit: 10,
    page: 0,
    accountCount: 0,
    supports: [],
    selected: {},
  };

  async componentDidMount() {
    // this.props.getWaittime();
    await this.getQueueCount();
    await this.getQueue();
  }

  onReload = async () => {
    await this.getQueueCount();
    await this.getQueue();
  };

  getQueueCount = async () => {
    const response = await this.props.getQueueCount({});
    if (response && response.count) {
      this.setState({ supportCount: response.count });
    }
  };

  getQueue = async (params) => {
    const { limit, page } = this.state;
    const skip = parseInt(page) * parseInt(limit);
    const supports = await this.props.getQueue({
      limit,
      skip,
      ...params,
    });
    this.setState({ supports, loading: false });
  };

  handleOpen = () => {
    this.setState({ isAdd: true });
  };

  handleClose = () => {
    this.onReload();
    this.setState({ isAdd: false, selected: null });
  };

  handleEdit = (selected) => {
    this.setState({ isAdd: true, selected });
  };

  handleChange = ({ limit, page }) => {
    this.setState({ limit, page }, this.getQueue);
  };

  timeOut = null;

  render() {
    const classes = this.props.classes;
    const { loading, isAdd, selected } = this.state;
    const supports = this.state.supports || [];

    return (
      <div>
        {isAdd && (
          <AddSupportForm
            isAdd={isAdd}
            handleClose={this.handleClose}
            selected={selected}
          />
        )}
        <Grid container className={classes.addWrapper}>
          <Grid item xs={12} sm={12} md={12}>
            <SearchBar
              handleAddClick={this.handleOpen}
              onSearch={this.getQueue}
            />
          </Grid>
        </Grid>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <SupportTable
              items={supports}
              count={this.state.supportCount}
              handleEdit={this.handleEdit}
              formatDate={this.props.formatDate}
              formatDateTime={this.props.formatDateTime}
              handleChange={this.handleChange}
              limit={this.state.limit}
              page={this.state.page}
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      formatDate,
      formatDateTime,
      getQueue,
      getQueueCount,
      getWaittime,
    },
    dispatch
  );

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Reseller)
);
